export default "__VITE_ASSET__DgqklE2j__"